module.exports = __webpack_public_path__ + "img/4.70369d21.jpg";